import { h, FunctionComponent } from 'preact';
import { useDispatch } from 'react-redux';
import { trackClick } from '~src/utils/tracking';

type LinkWrapperProps = {
  id: string;
  testId?: string;
  classLabel?: string;
  disabled?: boolean;
  trackingConfig?: {
    label: string;
    payload?: Object;
  };
  onClickHandler?: () => void;
  href?: string;
  target?: string;
};

const LinkWrapper: FunctionComponent<LinkWrapperProps> = ({
  id,
  testId = '',
  classLabel = '',
  disabled = false,
  trackingConfig,
  onClickHandler,
  children,
  href = '',
  target,
}) => {
  const dispatch = useDispatch();

  const onClickLink = (e: MouseEvent | TouchEvent) => {
    e.preventDefault();

    if (disabled) {
      return;
    }

    if (onClickHandler) {
      onClickHandler();
    }

    if (trackingConfig) {
      dispatch(trackClick(trackingConfig.label, trackingConfig.payload || {}));
    }
  };

  return (
    <a
      id={id}
      data-testid={testId}
      className={classLabel}
      type='button'
      role='button'
      href={href}
      tabIndex={0}
      disabled={disabled}
      onClick={onClickLink}
      target={target}
    >
      {children}
    </a>
  );
};

export default LinkWrapper;
